module.exports = __webpack_public_path__ + "static/media/recargar.1ba8aa94.png";